// Localization file, segregated based on game name.
// *** NOTE ***
// Those general info are used across different games
// should always maintained in general object to prevent
// double info. Please refer en.js as full example.

const zh = {
  general: {
    wallet: "投注余额",
    menulogout: "HOME",// "登出",
    goodroad: "蛟龙警报",
    menufavourite: "zhFavourite",
    favouritegame: "zhfavouritegame",
    availablegame: "zhavailablegame",
    menusfx: "SFX",
    menuon: "开",
    menuoff: "关",
    menurules: "规则",
    menuresult: "结果",
    menustatement: "账目",
    menunotification: "通告",
    menuviewhistory: "历史记录",
    menufullscreen: "全屏",
    marketclosed: "盘口已关闭",
    menutrend: "趋势",
    menusimple: "简单",
    menunormal: "标准",
    confirm: "确定",

    draw_no: "开奖编号",
    rebet: "重复投注",
    no_more_bet: "停止投注",
    sum: "总和",
    next_draw: "下一轮开奖",
    last_bets_for: "最后投注",
    bet_total: "投注总计",
    no_bets_last_round: "上一轮未投注。",
    max: "最大",
    payout: "奖金",
    min_to: "最小",
    max_to: "最大",
    cancel: "取消",
    bet: "投注",
    ref: "基准编号",
    gap: "差",

    sum_bs_short: "总和 大/小",
    sum_oe_short: "总和 单/双",
    Big: "大",
    Small: "小",
    Even: "双",
    Odd: "单",
    Dice: "骰子",
    Triple: "全围",
    High: "高",
    Low: "低",
    Black: "黑",
    Red: "红",
    Joker: "百搭牌",

    //for history TabPane
    Result: "结果",
    Sum_Player: "闲总和",
    Sum_Banker: "庄总和",
    SUM_OE: "单/双",
    SUM_BS: "大/小",
    CARD_HISTORY: "卡牌历史",
    STATISTICS: "统计",
    RED_BLACK: "红/黑",
    HI_LO: "上/下",
    Player: "闲",
    Tie: "和",
    Banker: "庄",

    PLACE_TICKET: "注",
    PLACE_FAIL: "投注失败！",
    PLACE_SUCCESS: "投注成功！",
    ERROR_MIN_TO: "抱歉，投注金额必须高于最低投注额！",
    ERROR_MAX_TO: "抱歉，投注金额不许超过最高投注额！",
    ERROR_MAX_DR: "抱歉，您已超过单轮最高投注！",
    ERROR_MAX_BTDR: "抱歉，该投注类别已超过单轮最高投注！",
    ERROR_NMB: "抱歉，停止下注。",
    ERROR_GAME_UA: "当前无法下注。请联系我们了解更多详情，谢谢。",
    ERROR_REBET_DONE: "抱歉，您已完成重复投注（上一轮投注选择）。",
    ERROR_TO: "抱歉，请重新输入投注金额！",
    ERROR_XAMOUNT: "抱歉，您的户口余额不足！",
    ERROR_206: "达到赢彩限额！请联系您的上线，谢谢。",
    ERROR_207: "达到输彩限额！请联系您的上线，谢谢。",
    ERROR_208: "账户已被冻结！请联系您的上线，谢谢。",
    ERROR_209: "账户禁用！请联系您的上线，谢谢。",
  },

  tai_xiu: {
    dicehistory: "骰子历史",
    o1group: "大/全围/小",
    o2group: "大/全围/小",
    o3group: "大/全围/小",
    o4group: "单/双",
    o5group: "单/双",

    o11group: "特定点数",
    o21group: "特定点数",
    o31group: "特定点数",
    o41group: "特定点数",
    o51group: "特定点数",
    o61group: "特定点数",
    o104group: "特定总点数",
    o105group: "特定总点数",
    o106group: "特定总点数",
    o107group: "特定总点数",
    o108group: "特定总点数",
    o109group: "特定总点数",
    o110group: "特定总点数",
    o111group: "特定总点数",
    o112group: "特定总点数",
    o113group: "特定总点数",
    o114group: "特定总点数",
    o115group: "特定总点数",
    o116group: "特定总点数",
    o117group: "特定总点数",

    o1: "大",
    o1_trend: "大",
    o2: "小",
    o2_trend: "小",
    o3: "全围",
    o3_trend: "AT",
    o4: "单",
    o4_trend: "单",
    o5: "双",
    o5_trend: "双",

    o11: "骰子 1",
    o12: "2x 骰子 1",
    o13: "3x 骰子 1",
    o21: "骰子 2",
    o22: "2x 骰子 2",
    o23: "3x 骰子 2",
    o31: "骰子 3",
    o32: "2x 骰子 3",
    o33: "3x 骰子 3",
    o41: "骰子 4",
    o42: "2x 骰子 4",
    o43: "3x 骰子 4",
    o51: "骰子 5",
    o52: "2x 骰子 5",
    o53: "3x 骰子 5",
    o61: "骰子 6",
    o62: "2x 骰子 6",
    o63: "3x 骰子 6",

    o104: "4",
    o104_trend: "4",
    o105: "5",
    o105_trend: "5",
    o106: "6",
    o106_trend: "6",
    o107: "7",
    o107_trend: "7",
    o108: "8",
    o108_trend: "8",
    o109: "9",
    o109_trend: "9",
    o110: "10",
    o110_trend: "10",
    o111: "11",
    o111_trend: "11",
    o112: "12",
    o112_trend: "12",
    o113: "13",
    o113_trend: "13",
    o114: "14",
    o114_trend: "14",
    o115: "15",
    o115_trend: "15",
    o116: "16",
    o116_trend: "16",
    o117: "17",
    o117_trend: "17",

    "1_dice": "单骰",
    "2_dice": "双骰",
    "3_dice": "三骰",
  },

  hi_lo: {
    o1: "上",
    o1_trend: "上",
    o2: "下",
    o2_trend: "下",
    o3: "红",
    o3_trend: "红",
    o4: "黑",
    o4_trend: "黑",
    o5: "范围 2-9",
    o5_trend: "2-9",
    o6: "范围 JQKA",
    o6_trend: "JQKA",
    o7: "范围 KA",
    o7_trend: "KA",
    o101: "A牌",
    o101_trend: "A",
    o102: "2牌",
    o102_trend: "2",
    o103: "3牌",
    o103_trend: "3",
    o104: "4牌",
    o104_trend: "4",
    o105: "5牌",
    o105_trend: "5",
    o106: "6牌",
    o106_trend: "6",
    o107: "7牌",
    o107_trend: "7",
    o108: "8牌",
    o108_trend: "8",
    o109: "9牌",
    o109_trend: "9",
    o110: "J牌",
    o110_trend: "J",
    o111: "Q牌",
    o111_trend: "Q",
    o112: "K牌",
    o112_trend: "K",
    o113: "百搭牌",
    o113_trend: "JK",

    //for new-bet-lot
    o1group: "上/下",
    o2group: "上/下",
    o3group: "红/黑",
    o4group: "红/黑",
    o5group: "特定范围",
    o6group: "特定范围",
    o7group: "特定范围",
    o101group: "特定牌",
    o102group: "特定牌",
    o103group: "特定牌",
    o104group: "特定牌",
    o105group: "特定牌",
    o106group: "特定牌",
    o107group: "特定牌",
    o108group: "特定牌",
    o109group: "特定牌",
    o110group: "特定牌",
    o111group: "特定牌",
    o112group: "特定牌",
    o113group: "特定牌",
  },

  domino: {
    result: "主要",
    main: "主要",
    o1: "闲",
    o1_trend: "闲",
    o2: "和",
    o2_trend: "/",
    o3: "庄",
    o3_trend: "庄",
    o4: "大",
    o4_trend: "大",
    o5: "小",
    o5_trend: "小",
    o6: "单",
    o6_trend: "单",
    o7: "双",
    o7_trend: "双",
    o8: "大",
    o8_trend: "大",
    o9: "小",
    o9_trend: "小",
    o10: "单",
    o10_trend: "单",
    o11: "双",
    o11_trend: "双",
    o12_trend: "/",

    //for new-bet-lot
    o1group: "闲/和/庄",
    o2group: "闲/和/庄",
    o3group: "闲/和/庄",
    o4group: "闲 大/小",
    o5group: "闲 大/小",
    o6group: "闲 单/双",
    o7group: "闲 单/双",
    o8group: "庄 大/小",
    o9group: "庄 大/小",
    o10group: "庄 单/双",
    o11group: "庄 单/双",

    P_BS: "闲 大/小",
    P_OE: "闲 单/双",
    B_BS: "庄 大/小",
    B_OE: "庄 单/双",

    PLAYER: "闲",
    BANKER: "庄",
    PLAYER_WIN: "闲赢",
    BANKER_WIN: "庄赢",
    TIE: "和",

    PLAYER_BIG: "闲大",
    PLAYER_SMALL: "闲小",
    PLAYER_ODD: "闲单",
    PLAYER_EVEN: "闲双",

    BANKER_BIG: "庄大",
    BANKER_SMALL: "庄小",
    BANKER_ODD: "庄单",
    BANKER_EVEN: "庄双",
  },

  fantan: {
    o1group: "Fan",
    o2group: "Ssh",
    o3group: "Kwok",
    o4group: "Nim",
    o5group: "Nga",
    o6group: "单/双",
    o7group: "和",
    total: "合计",
    odd: "单",
    even: "双",
    fan: "Fan",
    ssh: "Ssh",
    kwok: "Kwok",
    nga: "Nga",
    nim: "Nim",
    fan1: "Fan1",
    fan2: "Fan2",
    fan3: "Fan3",
    fan4: "Fan4",
    odd_trend: "单",
    even_trend: "双",
    result: "结果",
    history: "历史",
    OE: "单/双",
  },

  maxracing: {
    o1: "C(zh)",
    o1_trend: "C(zh)",
    o2: "Big(zh)",
    o2_trend: "B(zh)",
    o3: "Small(zh)",
    o3_trend: "S(zh)",
    o4: "Odd(zh)",
    o4_trend: "O(zh)",
    o5: "Even(zh)",
    o5_trend: "E(zh)",
    o6: "Big(zh)",
    o6_trend: "B(zh)",
    o7: "Small(zh)",
    o7_trend: "S(zh)",
    o8: "Odd(zh)",
    o8_trend: "O(zh)",
    o9: "Even(zh)",
    o9_trend: "E(zh)",
    o10: "G1(zh)",
    o10_trend: "G1(zh)",
    o11: "G2(zh)",
    o11_trend: "G2(zh)",
    o12: "G3(zh)",
    o12_trend: "G3(zh)",
    o13: "G4(zh)",
    o13_trend: "G5(zh)",
    o14: "G5(zh)",
    o14_trend: "G5(zh)",

    //for new-bet-lot
    o1group: "Player/Tie/Banker",
    o2group: "Player/Tie/Banker",
    o3group: "Player/Tie/Banker",
    o4group: "Player Big/Small",
    o5group: "Player Big/Small",
    o6group: "Player Odd/Even",
    o7group: "Player Odd/Even",
    o8group: "Banker Big/Small",
    o9group: "Banker Big/Small",
    o10group: "Banker Odd/Even",
    o11group: "Banker Odd/Even",

    Champion: "Champion(zh)",
    C_BS: "C B/S(zh)",
    C_OE: "C O/E(zh)",
    S_BS: "S B/S(zh)",
    S_OE: "S O/E(zh)",
    Group: "Group(zh)",
    Place_champ: "Place Champion(zh)",
    Place_sum_champ: "Place Sum Champion(zh)",
    Runner_up: "Runner-up(zh)",
    Race_result: "Race Result(zh)",
  },

  thai_hilo: {
    triple: "zhTriple",
    o1: "ZHHigh",
    o1group: "ZHHigh/Low",
    o1_trend: "ZHH",
    o2: "ZHLow",
    o2group: "ZHHigh/Low",
    o2_trend: "ZHL",
    o3: "ZH11 HiLo",
    o3_trend: "ZH11",
    o3group: "ZH11 HiLo",
    o4: "ZH6 Lo",
    o4group: "ZHLo",
    o4_trend: "ZH6L",
    o5: "ZH5 Lo",
    o5group: "ZHLo",
    o5_trend: "ZH5L",
    o6: "ZH3 Lo",
    o6group: "ZHLo",
    o6_trend: "ZH3L",
    o7: "ZH1 Lo",
    o7group: "ZHLo",
    o7_trend: "ZH1L",
    o8: "ZH6 Hi",
    o8group: "ZHHi",
    o8_trend: "ZH6H",
    o9: "ZH4 Hi",
    o9group: "ZHHi",
    o9_trend: "ZH4H",

    o11: "ZH1",
    o11group: "ZHSingle Digit",
    o11_trend: "ZH1",
    o21: "ZH2",
    o21group: "ZHSingle Digit",
    o21_trend: "ZH2",
    o31: "ZH3",
    o31group: "ZHSingle Digit",
    o31_trend: "ZH3",
    o41: "ZH4",
    o41group: "ZHSingle Digit",
    o41_trend: "ZH4",
    o51: "ZH5",
    o51group: "ZHSingle Digit",
    o51_trend: "ZH5",
    o61: "ZH6",
    o61group: "ZHSingle Digit",
    o61_trend: "ZH6",

    o70: "ZH1-2",
    o70group: "ZHTwo Digit",
    o70_trend: "ZH1-2",
    o71: "ZH1-3",
    o71group: "ZHTwo Digit",
    o71_trend: "ZH1-3",
    o72: "ZH2-3",
    o72group: "ZHTwo Digit",
    o72_trend: "ZH2-3",
    o73: "ZH3-4",
    o73group: "ZHTwo Digit",
    o73_trend: "ZH3-4",
    o74: "ZH4-1",
    o74group: "ZHTwo Digit",
    o74_trend: "ZH4-1",
    o75: "ZH4-2",
    o75group: "ZHTwo Digit",
    o75_trend: "ZH4-2",
    o76: "ZH4-5",
    o76group: "ZHTwo Digit",
    o76_trend: "ZH4-5",
    o77: "ZH4-6",
    o77group: "ZHTwo Digit",
    o77_trend: "ZH4-6",
    o78: "ZH5-1",
    o78group: "ZHTwo Digit",
    o78_trend: "ZH5-1",
    o79: "ZH5-2",
    o79group: "ZHTwo Digit",
    o79_trend: "ZH5-2",
    o80: "ZH5-3",
    o80group: "ZHTwo Digit",
    o80_trend: "ZH5-3",
    o81: "ZH5-6",
    o81group: "ZHTwo Digit",
    o81_trend: "ZH5-6",
    o82: "ZH6-1",
    o82group: "ZHTwo Digit",
    o82_trend: "ZH6-1",
    o83: "ZH6-2",
    o83group: "ZHTwo Digit",
    o83_trend: "ZH6-2",
    o84: "ZH6-3",
    o84group: "ZHTwo Digit",
    o84_trend: "ZH6-3",

    o85: "ZH1-2-3",
    o85group: "ZHThree Digit",
    o85_trend: "ZH1-2-3",
    o86: "ZH4-5-6",
    o86group: "ZHThree Digit",
    o86_trend: "ZH4-5-6",
    o87: "ZH1-3-5",
    o87group: "ZHThree Digit",
    o87_trend: "ZH1-3-5",
    o88: "ZH2-4-6",
    o88group: "ZHThree Digit",
    o88_trend: "ZH2-4-6",
    o89: "ZH1-2-3",
    o89group: "ZHThree Digit",
    o89_trend: "ZH1-2-3",
    o90: "ZH3-4-5",
    o90group: "ZHThree Digit",
    o90_trend: "ZH3-4-5",
    o91: "ZH1-3-5",
    o91group: "ZHThree Digit",
    o91_trend: "ZH1-3-5",
    o92: "ZH2-4-6",
    o92group: "ZHThree Digit",
    o92_trend: "ZH2-4-6",
  },
};

export default zh;
